<template>
  <div class="error-box">
    <div class="error-center">
      <img src="../../assets/img/404.png"/>
      <div class="font-box">
        <span class="error">ERROR</span>
        <span class="tips">非常抱歉，您访<br>问的页面不存在</span>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'error',
    data() {
      return {};
    },
    mounted() {
    },
    beforeDestroy() {
    }
  };
</script>

<style lang="less" scoped>
  .error-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .error-center {
      text-align: center;

      img {
        width: 80%;
      }

      .font-box {
        width: 100%;
        text-align: center;
        padding-top: 20px;

        span {
          display: inline-block;
          vertical-align: middle;
          font-size: 38px;
          font-weight: bold;
        }

        span.error {
          /*color: #296184;*/
          color: #f05259;
        }

        span.tips {
          color: #aaaab2;
          font-size: 14px;
          font-weight: normal;
          padding-left: 10px;
        }
      }

    }


  }
</style>
